var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeleteIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.313,
    height: 23.775,
    viewBox: "0 0 22.313 23.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_140",
    "data-name": "Subtraction 140",
    d: "M14719.6-21880.227h-8.884a4.06,4.06,0,0,1-1.6-.318,4.257,4.257,0,0,1-1.357-.9,4.276,4.276,0,0,1-.9-1.357,4.215,4.215,0,0,1-.319-1.6v-13.6H14705a1,1,0,0,1-1-1,1,1,0,0,1,1-1h5.349v-1.094a2.9,2.9,0,0,1,.22-1.115,2.836,2.836,0,0,1,.633-.939,2.886,2.886,0,0,1,.939-.633,2.9,2.9,0,0,1,1.116-.221h3.8a2.853,2.853,0,0,1,1.111.221,2.872,2.872,0,0,1,.945.633,2.954,2.954,0,0,1,.632.939,3,3,0,0,1,.22,1.115v1.094h5.344a1,1,0,0,1,1,1,1,1,0,0,1-1,1h-1.539v13.6a4.194,4.194,0,0,1-1.221,2.957A4.218,4.218,0,0,1,14719.6-21880.227Zm-1.9-13.309a1,1,0,0,0-1,1v6.344a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-6.344A1,1,0,0,0,14717.7-21893.535Zm-5.079,0a1,1,0,0,0-1,1v6.344a1,1,0,0,0,1,1,1,1,0,0,0,1-1v-6.344A1,1,0,0,0,14712.618-21893.535Zm.632-8.465a.9.9,0,0,0-.346.066.958.958,0,0,0-.291.2.891.891,0,0,0-.2.291.982.982,0,0,0-.066.352v1.094h5.618v-1.094a.845.845,0,0,0-.071-.352.865.865,0,0,0-.192-.291,1.064,1.064,0,0,0-.3-.2.9.9,0,0,0-.347-.066Z",
    transform: "translate(-14703.999 21904.002)",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIconHover);
export default __webpack_public_path__ + "static/media/DeleteIconHover.bab87539585e01a964200529402d72c9.svg";
export { ForwardRef as ReactComponent };